import { Ruler } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const TOPS = [["S", 22, 27.5], ["M", 23, 28.5], ["L", 24.5, 29.5], ["XL", 26, 30.5], ["2XL", 27.5, 31.5]];
const SHORTS = [["S", "28-30", 5], ["M", "31-33", 5], ["L", "34-36", 5], ["XL", "37-39", 5], ["2XL", "40-42", 5]];
const SOCKS = [["S/M", "M 4-8.5 / W 5.5-10"], ["L/XL", "M 9-13 / W 10.5-13"]];

export const SizeGuide = ({ product }) => {
  const isShorts = product.slug === "interval-shorts";
  const isSocks = (product.sizes || []).includes("S/M");
  const rows = isShorts ? SHORTS : isSocks ? SOCKS : TOPS;
  const head = isShorts ? ["SIZE", "WAIST (IN)", "INSEAM (IN)"] : isSocks ? ["SIZE", "US SHOE"] : ["SIZE", "PIT TO PIT (IN)", "LENGTH (IN)"];
  const note = isShorts
    ? "Elastic waistband with internal drawcord — if between sizes, size down."
    : isSocks
      ? "Snug performance fit with arch support."
      : "City tees and tops run oversized. For a regular fit, size down one.";
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid="size-guide-button"
          className="font-mono-label text-white/50 hover:text-white underline underline-offset-4 decoration-white/30 hover:decoration-white flex items-center gap-1.5 ml-2 transition-colors duration-200"
        >
          <Ruler size={13} /> SIZE GUIDE
        </button>
      </DialogTrigger>
      <DialogContent className="bg-ink border-white/15 text-white max-w-md" data-testid="size-guide-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase text-left">Size Guide</DialogTitle>
        </DialogHeader>
        <table className="w-full text-sm mt-2" data-testid="size-guide-table">
          <thead>
            <tr className="border-b border-white/15">
              {head.map((h) => (
                <th key={h} className="font-mono-label text-white/40 text-left py-2 pr-4 font-normal">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r[0]} className="border-b border-white/10">
                {r.map((c, i) => (
                  <td key={`${r[0]}-${i}`} className={`py-2.5 pr-4 ${i === 0 ? "font-mono-label text-white/80" : "text-white/60"}`}>{c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-white/50 text-xs leading-relaxed mt-1">{note} Measurements are garment measurements, laid flat.</p>
      </DialogContent>
    </Dialog>
  );
};
